// @flow

import type {
  SetSearchNotificationsAction,
  SetSearchNotificationsPayload,
  SearchNotification,
  SearchNotificationsState,
  UpdateSearchNotificationSuccessAction,
  UpdateSearchNotificationSuccessPayload,
} from './types';
import type {
  DeleteSearchNotificationSuccessAction,
  DeleteSearchNotificationSuccessPayload,
  DeleteSearchNotificationErrorAction,
  DeleteSearchNotificationErrorPayload,
} from '../DeleteSearchNotification/types';
import initialState from './initialState';
import { SET_SEARCH_NOTIFICATIONS, UPDATE_SEARCH_NOTIFICATION_SUCCESS } from './actionTypes';
import {
  DELETE_SEARCH_NOTIFICATION_SUCCESS,
  DELETE_SEARCH_NOTIFICATION_ERROR,
} from '../DeleteSearchNotification/actionTypes';
import { replaceSearchNotification, updateChangeStatus, removeSearchNotification } from './utils';

export default (
  state: SearchNotificationsState = initialState,
  action:
    | SetSearchNotificationsAction
    | UpdateSearchNotificationSuccessAction
    | DeleteSearchNotificationSuccessAction
    | DeleteSearchNotificationErrorAction
): SearchNotificationsState => {
  switch (action.type) {
    case SET_SEARCH_NOTIFICATIONS: {
      const searchNotifications: SearchNotification<*>[] = state;
      const {
        searchNotifications: newSearchNotifications,
      }: SetSearchNotificationsPayload = action.payload;
      return newSearchNotifications.map(newSearchNotification =>
        updateChangeStatus(searchNotifications, newSearchNotification)
      );
    }

    case UPDATE_SEARCH_NOTIFICATION_SUCCESS: {
      const searchNotifications: SearchNotification<*>[] = state;
      const { searchNotification }: UpdateSearchNotificationSuccessPayload = action.payload;
      const updatedSearchNotification = updateChangeStatus(searchNotifications, searchNotification);
      return replaceSearchNotification(searchNotifications, updatedSearchNotification);
    }

    case DELETE_SEARCH_NOTIFICATION_SUCCESS: {
      const searchNotifications: SearchNotification<*>[] = state;
      const { searchNotification }: DeleteSearchNotificationSuccessPayload = action.payload;
      return removeSearchNotification(searchNotifications, searchNotification);
    }

    case DELETE_SEARCH_NOTIFICATION_ERROR: {
      const { searchNotifications }: DeleteSearchNotificationErrorPayload = action.payload;
      return [...searchNotifications];
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/reducer.js